let loaded = false
let readyPromise = null

function loadScript () {
  if (readyPromise) { return readyPromise }
  readyPromise = new Promise((resolve, reject) => {
    if (loaded && window.smartCaptcha) { return resolve() }
    const s = document.createElement('script')
    s.src = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload'
    s.async = true
    s.onload = () => {
      loaded = true
      resolve()
    }
    s.onerror = () => reject(new Error('Не удалось загрузить SmartCaptcha'))
    document.head.appendChild(s)
  })
  return readyPromise
}

export default async (_ctx, inject) => {
  await loadScript()
  inject('smartcaptcha', {
    ready: async () => { await loadScript() },
    render: (container, options) => window.smartCaptcha.render(container, options),
    reset: () => { try { window.smartCaptcha.reset() } catch (e) {} },
  })
}
